import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { usePostHog } from 'posthog-js/react'
import { api } from '../api/client'
import WelcomeStep from '../components/Onboarding/WelcomeStep'
import ProfileStep from '../components/Onboarding/ProfileStep'
import PathStep from '../components/Onboarding/PathStep'
import './OnboardingPage.css'

export default function OnboardingPage() {
    const [step, setStep] = useState(1)
    const navigate = useNavigate()
    const posthog = usePostHog()

    const handleSkip = async (skippedAtStep: number) => {
        posthog.capture('onboarding_skipped', { skippedAtStep })
        // Mark onboarding dismissed so the wizard won't show again, but leave
        // OnboardingCompleted = false so the checklist renders on Dashboard.
        try {
            await api.updateUserProfile({ onboardingDismissed: true })
        } catch {
            // Best-effort — navigate anyway
        }
        navigate('/dashboard')
    }

    return (
        <div className="onboarding-page" role="main">
            {/* Progress dots */}
            <div className="onboarding-progress" role="progressbar" aria-valuenow={step} aria-valuemin={1} aria-valuemax={3}>
                {[1, 2, 3].map((n) => (
                    <span
                        key={n}
                        className={`progress-dot${n === step ? ' progress-dot--active' : n < step ? ' progress-dot--done' : ''}`}
                        aria-label={`Step ${n}${n === step ? ' (current)' : n < step ? ' (completed)' : ''}`}
                    />
                ))}
            </div>

            <div className="onboarding-content">
                {step === 1 && (
                    <WelcomeStep onNext={() => setStep(2)} onSkip={handleSkip} />
                )}
                {step === 2 && (
                    <ProfileStep onNext={() => setStep(3)} onSkip={handleSkip} />
                )}
                {step === 3 && (
                    <PathStep onSkip={handleSkip} />
                )}
            </div>
        </div>
    )
}
